import { memo } from 'react';
import { IUniqkeyImageProp } from '../interfaces';
import iPhoneImage from './assets/iPhoneImage.png';

const IphoneImage = (props: IUniqkeyImageProp) => {
  const { width = 306, height = 246 } = props;
  return (
    <img src={iPhoneImage} alt="iPhone" width={width} height={height} />
  );
};

export default memo(IphoneImage);
